import { UIInput } from '../../types/uiTypes';
import { getUserByUsernameQuery } from '../queries/getUserByUsernameQuery';

export interface GetUserByUsernameInput extends UIInput {
  username: string;
}

export interface GetUserByUsernameOutput {
  userId: string;
  givenName: string;
  familyName: string;
  vendorIds: string[];
  applications: string[];
  onboardStatus: string;
}

export async function getUserByUsername({
  apolloClient,
  username
}: GetUserByUsernameInput): Promise<GetUserByUsernameOutput> {
  const queryVariables = { username };

  const response = await apolloClient.query({
    query: getUserByUsernameQuery,
    variables: queryVariables,
    fetchPolicy: 'network-only'
  });

  return response.data.getUserByUsername.user as GetUserByUsernameOutput;
}
